import { defineMessages } from 'react-intl';

export const filterCompositionApplyButtonMessages = defineMessages({
  fetch: {
    defaultMessage: 'Fetch',
    id: 'qmg3pklvpZVXsOtz',
    description: 'Label for the FilterComposition apply button in fetch state.',
  },
  apply: {
    defaultMessage: 'Apply',
    id: 'jrVbPKGmxrR1NB9u',
    description: 'Label for the FilterComposition apply button in apply state.',
  },
  refresh: {
    defaultMessage: 'Refresh',
    id: '30K8AZbf0dT3VJZ3',
    description:
      'Label for the FilterComposition apply button in refresh state.',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'Wp5mn30lXgxkfTYx',
    description:
      'Label for the FilterComposition apply button in loading/cancel state.',
  },
});
